import { IndicatorsOfRiskModule, PhasrModule } from '@nirvana/shared/dtos/types/policies/common';

// UI form value format
export interface IndicatorsOfRiskFormValue {
  uiSettings: { indicatorsOfRisk: IndicatorsOfRiskModule; phasr: PhasrModule };
}

// searchable keywords
export enum IndicatorsOfRiskSearchableKeywords {
  RiskManagement = 'RiskManagement',
  RiskScheduler = 'RiskScheduler',
  RiskRecurrence = 'RiskRecurrence',
  RiskRunAsSoonAsPossible = 'RiskRunAsSoonAsPossible',
  NSVAExclusions = 'NSVAExclusions',
  Phasr = 'Phasr',
  TamperingTools = 'TamperingTools',
  LOLBins = 'LOLBins',
  Miners = 'Miners',
  HackTools = 'HackTools',
  RemoteAdminTools = 'RemoteAdminTools',
}
